
<div class="row">
	<div class="col-md-6">
		{{'adminstat.common.All count' | translate }}: <span class="badge badge-secondary" [sextant]="'total'">{{totalCount}}</span>
		{{'adminstat.common.In query count' | translate }}: <span class="badge badge-secondary" [sextant]="'in-query'">{{filterCount}}</span>
		
		<loading [isLoad]="totalLoader"></loading>
	</div>
	
	<div class="col-md-6">
		<cache-date></cache-date>
	</div>
</div>

<hr/>

<div class="row">
	<div class="col-md-12">
		<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>
	</div>
</div>

<hr/>

<div class="row">
	<div class="col-md-12">
		<ngb-pagination
			[extlinks]="links"
			[collectionSize]="pagination.pageCount"
			[maxSize]="10"
			[pageSize]="1"
			[(page)]="pagination.page"
			[boundaryLinks]="true"
			(pageChange)="onPageChange()"
			*ngIf="!paginationLoader"
		></ngb-pagination>
		
		<loading [isLoad]="paginationLoader"></loading>
	</div>
</div>

<hr/>

<div class="row">
	<div class="col-md-12">
		<loading [isLoad]="loadingInProgress"></loading>
	</div>
</div>

<hr/>

<div class="row" *ngIf="!loadingInProgress && stats.length > 0">
	<div
		class="col-md-12"
	>
		<span
			class="button-download-link"
			(click)="downloadButton('cc')"
			[sextant]="'call_center_download'"
		>
			<i class="fa fa-download" aria-hidden="true"></i> КЦ
		</span>
		
		<span
			class="button-download-link ml-4"
			(click)="downloadButton('data')"
			[sextant]="'data_download'"
		>
			<i class="fa fa-download" aria-hidden="true"></i> Данные
		</span>
		
		<span
			class="button-download-link ml-4"
			(click)="downloadButton('apps')"
			[sextant]="'app_download'"
		>
			<i class="fa fa-download" aria-hidden="true"></i> Users with apps
		</span>
		
		<span
			class="button-download-link ml-4"
			(click)="downloadButton('phones')"
			[sextant]="'phones_download'"
		>
			<i class="fa fa-download" aria-hidden="true"></i> Users with phones
		</span>
		
		<span
			class="button-download-link ml-4 float-right"
			(click)="toggleSort('paid_expired')"
			[sextant]="'paid_expired_sort'"
		>
			<i class="fas" [ngClass]="getSortClasses('paid_expired')"></i>
			{{'adminstat.site.published_site.paid_expired' | translate }}
		</span>
		
		<span
			class="button-download-link ml-4 float-right"
			(click)="toggleSort('date_create')"
			[sextant]="'date_create_sort'"
		>
			<i class="fas" [ngClass]="getSortClasses('date_create')"></i>
			{{'adminstat.common.date_create' | translate }}
		</span>
	</div>
	
	<div class="col-md-12">
		<table class="table table-bordered table-responsive">
			<thead>
				<tr>
					<th></th>
					
					<th>
						Сайт
					</th>
					
					<th>
						site info
					</th>
					
					<th>
						user info
					</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let site of stats">
					<td>
						<a href="{{site.dashboardUrl}}" target="_blank" rel="noreferrer"><i class="fa fa-tachometer-alt fa-lg" aria-hidden="true"></i></a>
					</td>
					
					<td>
						<site_info [siteUrl]="site.domainUrl" style="display: inline-block;"></site_info>
					</td>
					
					<td>
						<table class="table table-responsive">
							<tbody>
								<tr>
									<td class="ul-table-date-container">
										{{ 'adminstat.common.date_create' | translate }}
									</td>
									
									<td>
										<div class="ul-table-date-container">
											{{ site.dateCreate | date:"dd.MM.yyyy HH:mm" }}
										</div>
									</td>
								</tr>
								
								<tr>
									<td>
										{{ 'adminstat.site.published_site.date published' | translate }}
									</td>
									
									<td>
										<div class="ul-table-date-container" *ngIf="site.datePublished">
											{{ site.datePublished | date:"dd.MM.yyyy HH:mm" }}
										</div>
									</td>
								</tr>
								
								<tr>
									<td>
										{{ 'adminstat.site.published_site.paid_expired' | translate }}
									</td>
									
									<td>
										<div class="ul-table-date-container" *ngIf="site.lastInvoice">
											{{ site.lastInvoice.dateTo | date:"dd.MM.yyyy HH:mm" }}
										</div>
									</td>
								</tr>
								
								
								<tr>
									<td>
										{{ 'adminstat.common.Subject' | translate }}
									</td>
									
									<td>
										{{ site.subjectId }}
									</td>
								</tr>
								
								<tr>
									<td>
										{{ 'adminstat.common.domains' | translate }}
									</td>
									
									<td>
										<ul *ngIf="site.domains.length > 0">
											<li *ngFor="let domain of site.domains">
												<a target="_blank" rel="noreferrer" href="http://{{domain}}">
													{{ domain }}
												</a>
											</li>
										</ul>
									</td>
								</tr>
								
								<tr>
									<td>
										{{ 'adminstat.site.published_site.phone list' | translate }}
									</td>
									
									<td>
										<ng-template [ngIf]="site.phonesFromUser.length > 0">
											{{ 'adminstat.common.phone dashnoard history' | translate }}:
											
											<ul>
												<li *ngFor="let phone of site.phonesFromUser">
													<a [href]="'tel:' + phone">{{ phone | phoneFormat }}</a>
												</li>
											</ul>
											
											<hr>
										</ng-template>
										
										
										<ng-template [ngIf]="site.phonesFromSites.length > 0">
											<ngb-accordion #acc="ngbAccordion">
												<ngb-panel title="{{ 'adminstat.common.sites' | translate }} ({{site.phonesFromSites.length}})">
													<ng-template ngbPanelContent>
														<ul>
															<li *ngFor="let phone of site.phonesFromSites">
																<a [href]="'tel:' + phone">{{ phone | phoneFormat }}</a>
															</li>
														</ul>
													</ng-template>
												</ngb-panel>
											</ngb-accordion>
											
											<hr>
										</ng-template>
										
										<ng-template [ngIf]="site.phonesFromExternalData.length > 0">
											<ngb-accordion #acc="ngbAccordion">
												<ngb-panel title="{{ 'adminstat.common.external data' | translate }} ({{site.phonesFromExternalData.length}})">
													<ng-template ngbPanelContent>
														<ul>
															<li *ngFor="let phone of site.phonesFromExternalData">
																<a [href]="'tel:' + phone">{{ phone | phoneFormat }}</a>
															</li>
														</ul>
													</ng-template>
												</ngb-panel>
											</ngb-accordion>
										</ng-template>
									</td>
								</tr>
							</tbody>
						</table>
					</td>
					
					<td>
						<table class="table table-responsive">
							<tbody>
								<tr>
									<td>
										{{ 'adminstat.common.Username' | translate }}
									</td>
									
									<td>
										{{ site.username }}
									</td>
								</tr>
								<tr>
									<td>
										{{ 'adminstat.common.Email' | translate }}
									</td>
									
									<td>
										<gotosupport [value]="site.email"></gotosupport>
									</td>
								</tr>
							</tbody>
						</table>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>

<div class="row" *ngIf="typeDate=='created' && !loadingInProgress">
	<div class="col-md-12">
		<table class="table table-bordered">
			<thead>
				<tr>
					<th></th>
					<th></th>
					
					<th>
						user
					</th>
					
					<th>
						site
					</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let user of stats">
					<td>
						<span class="badge badge-pill" [ngClass]="user.datePublished ? 'badge-success' : 'badge-danger'">&nbsp;</span>
					</td>
	
					<td>
						<a *ngIf="user.domainUrl" href="http://ukit.com/sites/url/{{user.domainUrl}}/dashBoard" target="_blank" rel="noreferrer"><i class="fa fa-tachometer fa-lg" aria-hidden="true"></i></a>
					</td>
					
					<td>
						<table class="table table-responsive">
							<tbody>
								<tr>
									<td>
										{{ 'adminstat.site.published_site.User reg date' | translate }}
									</td>
									
									<td>
										{{user.created | date:"dd.MM.yyyy HH:mm"}}
									</td>
								</tr>
								<tr>
									<td>
										{{ 'adminstat.common.Email' | translate }}
									</td>
									
									<td>
										<gotosupport [value]="user.email"></gotosupport>
									</td>
								</tr>
								
								
								<tr>
									<td>
										{{ 'adminstat.common.Username' | translate }}
									</td>
									
									<td>
										<a class="js-ul-user-info" href="#">{{user.username}}</a>
									</td>
								</tr>
							</tbody>
						</table>
					</td>
					
					<td>
						<table class="table table-responsive">
							<tbody>
								<tr>
									<td>
										{{ 'adminstat.site.published_site.first site' | translate }}
									</td>
									
									<td>
										<a target="_blank" rel="noreferrer" href="http://{{user.domainUrl}}/">{{user.domainUrl}}</a>
									</td>
								</tr>
								
								<tr>
									<td>
										{{ 'adminstat.common.Subject' | translate }}
									</td>
									
									<td>
										{{user.subjectId}}
									</td>
								</tr>
								
								<tr>
									<td>
										{{ 'adminstat.site.published_site.Site reg date' | translate }}
									</td>
									
									<td>
										{{user.dateCreate | date:"dd.MM.yyyy HH:mm"}}
									</td>
								</tr>
							</tbody>
						</table>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>

<div class="row" *ngIf="typeDate=='subject' && !loadingInProgress">
	<div class="col-md-12">
		<table class="table table-bordered">
			<thead>
			<tr>
				<th>{{ 'adminstat.common.Date' | translate }}</th>
				<th>{{ 'adminstat.common.sites' | translate }}</th>
			</tr>
			</thead>
			<tbody>
			<tr *ngFor="let day of stats">
				<td>
					{{day.timestamp}}
				</td>
				<td>
					<table class="table table-hover table-responsive">
						<thead>
						<tr>
							<th>
								Total
							</th>
							<th>
								{{total(day.sites)}}
							</th>
						</tr>
						</thead>
						<tr *ngFor="let site of day.sites">
							<td>
								{{site.subjectId}}
							</td>
							<td>
								{{site.count}}({{helper.percentageFormat(site.count / total(day.sites))}})
							</td>
						</tr>
					</table>
				</td>
			</tr>
			</tbody>
		</table>
	</div>
</div>

